<template>
  <div class="statuts">
    <h4 class="mt-1 mb-3 infos-title">Situation administrative</h4>
    <hr class="mx-0 mb-2" />
    <p v-if="parc.statutAdministratif">
      Régime ICPE :
      <i v-if="parc.statutAdministratif">{{parc.statutAdministratif.description}}</i>
      <i class="empty-field" v-else>{{ emptyField }}</i>
    </p>
    <p>
      Statut :
      <i v-if="parc.statutParc">{{ parc.statutParc.libelle }}</i>
      <i v-else class="empty-field">
        <small>Toutes les dates nécessaires au calcul du statut ne sont pas encore renseignées</small>
      </i>
    </p>
    <p v-if="parc.etatParc">
      Etat : <i>{{ parc.etatParc.libelle }}</i>
    </p>
    <p v-if="isDreal && parc.statutSaisie">
      Statut de saisie : <i>{{ parc.statutSaisie.description }}</i>
    </p>
    <p v-if="parc.id">
      Numéro ICPE : <i>{{ parc.id }}</i>
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'StatusSection',
  computed: {
    ...mapGetters({
      parc: "parc",
      isDreal: "isDreal"
    })
  },
  data() {
    return {
      emptyField: 'Non renseigné'
    }
  }
}
</script>
